import { Badge, Table, Text } from "@chakra-ui/react";
// import { ImageBasic } from "./Image";
// import { VariableSizeList as List } from "react-window";

const size = "md";

// const Rows3 = (props) => {
//   const arrlen = props?.items?.length || 0;

//   const rowHeights = new Array(arrlen).fill(true).map(() => 40);

//   const getItemSize = (index) => rowHeights[index];

//   //   {
//   //     "position": "absolute",
//   //     "left": 0,
//   //     "top": 0,
//   //     "height": 40,
//   //     "width": "100%"
//   // }

//   const RowR3 = ({ index, style, items }) =>
//     items[index] ? (
//       <Item style={style} item={items[index]} index={index} {...props} />
//     ) : (
//       <></>
//     );

//   return (
//     <List height={400} width="100%" itemCount={arrlen} itemSize={getItemSize}>
//       {RowR3}
//     </List>
//   );
// };

// const Rows2 = ({ onClickItm, selectedId, items }) => {
//   return (
//     <For each={items}>
//       {(item, index) => (
//         <Table.Row key={`i-${index}`}>
//           {Object.keys(item).map((b, index2) => {
//             if (!b || b === "id" || b === "temp" || b === "data") {
//               return null;
//             }
//             if (b === "actions") {
//               return (
//                 <Table.Cell
//                   key={`i2-${index2}`}
//                   bg={
//                     item.id === selectedId ? "table.activeitem" : "transparent"
//                   }
//                   fontSize={"xl"}
//                   onClick={() => onClickItm({ item, key: item[b], index })}
//                 >
//                   <Flex gap={"0.2rem"}>
//                     {item[b]?.includes("print") ? (
//                       <Button
//                         p={0}
//                         m={0}
//                         variant={"plain"}
//                         onClick={() =>
//                           onClickItm({
//                             action: "print",
//                             item,
//                             key: item[b],
//                             index,
//                           })
//                         }
//                       >
//                         <ImageBasic src={"img/img_ic_print.png"} w={"1.5rem"} />
//                       </Button>
//                     ) : null}
//                     {item[b]?.includes("del") ? (
//                       <Button
//                         p={0}
//                         m={0}
//                         variant={"plain"}
//                         onClick={() =>
//                           onClickItm({
//                             action: "del",
//                             item,
//                             key: item[b],
//                             index,
//                           })
//                         }
//                       >
//                         <ImageBasic src={"img/img_ic_del.png"} w={"1.5rem"} />
//                       </Button>
//                     ) : null}
//                   </Flex>
//                 </Table.Cell>
//               );
//             }
//             return (
//               <Table.Cell
//                 key={`i2-${index2}`}
//                 bg={item.id === selectedId ? "table.activeitem" : "transparent"}
//                 fontSize={"xl"}
//                 onClick={() => onClickItm({ item, key: item[b], index })}
//               >
//                 {item && item[b] ? item[b] : ""}
//               </Table.Cell>
//             );
//           })}
//           {/* <Table.Cell fontSize={"xl"}>{item.category}</Table.Cell> */}
//           {/* <Table.Cell textAlign="end" fontSize={"xl"}> */}
//           {/* {item.price} */}
//           {/* </Table.Cell> */}
//         </Table.Row>
//       )}
//     </For>
//   );
// };

const Item = ({ index, selectedId, onClickItm, item }) => (
  <Table.Row key={`row-${index}`}>
    {Object.keys(item).map((b, index2) => {
      if (!b || b === "id" || b === "temp" || b === "data") {
        return null;
      }

      // if (b === "actions") {
      //   return (
      //     <Table.Cell
      //       key={`cell-${index}-${index2}`}
      //       bg={item.id === selectedId ? "table.activeitem" : "transparent"}
      //       fontSize={size}
      //       onClick={() => onClickItm({ item, key: item[b], index })}
      //     >
      //       <Flex gap={"0.2rem"}>
      //         {item[b]?.includes("print") ? (
      //           <Button
      //             p={0}
      //             m={0}
      //             variant={"plain"}
      //             onClick={() =>
      //               onClickItm({
      //                 action: "print",
      //                 item,
      //                 key: item[b],
      //                 index,
      //               })
      //             }
      //           >
      //             <ImageBasic src={"img/img_ic_print.png"} w={"1.5rem"} />
      //           </Button>
      //         ) : null}
      //         {item[b]?.includes("del") ? (
      //           <Button
      //             p={0}
      //             m={0}
      //             variant={"plain"}
      //             onClick={() =>
      //               onClickItm({
      //                 action: "del",
      //                 item,
      //                 key: item[b],
      //                 index,
      //               })
      //             }
      //           >
      //             <ImageBasic src={"img/img_ic_del.png"} w={"1.5rem"} />
      //           </Button>
      //         ) : null}
      //       </Flex>
      //     </Table.Cell>
      //   );
      // }

      if (item && item[b]?.cellStyle) {
        let bg = "transparent";
        if (item[b]?.cellStyle?.bg) {
          bg = item[b].cellStyle.bg;
        }
        return (
          <Table.Cell
            key={`cell-${index}-${index2}`}
            fontSize={size}
            onClick={() => onClickItm({ item, key: item[b], index })}
            // color={"textv2.brand"}
            color={item.id === selectedId ? "white" : "textv2.brand"}
            {...item[b]?.cellStyle}
            bg={item.id === selectedId ? "table.activeitem" : bg}
          >
            <Text
              {...item[b]?.cellStyle?.textStyle}
              color={
                item.id === selectedId
                  ? "white"
                  : item[b]?.cellStyle?.textStyle?.color
              }
            >
              {item && item[b]?.label ? item[b].label : ""}
            </Text>
          </Table.Cell>
        );
      }

      if (item && item[b]?.clr) {
        return (
          <Table.Cell
            key={`cell-${index}-${index2}`}
            // bg={item[b]?.clr}
            bg={item.id === selectedId ? "table.activeitem" : "transparent"}
            fontSize={size}
            onClick={() => onClickItm({ item, key: item[b], index })}
          >
            <Badge size={"md"} colorPalette={item[b]?.clr}>
              {item && item[b]?.label ? item[b].label : ""}
            </Badge>
          </Table.Cell>
        );
      }

      return (
        <Table.Cell
          key={`cell-${index}-${index2}`}
          bg={item.id === selectedId ? "table.activeitem" : "transparent"}
          fontSize={size}
          onClick={() => onClickItm({ item, key: item[b], index })}
        >
          {item && item[b] ? (
            <Text
              // color={"textv2.brand"}
              color={item.id === selectedId ? "white" : "textv2.brand"}
              // alignSelf={'flex-start'}
              // textAlign={utils.checkTwoDecimalPoints(item[b]) ? "end" : "start"}
            >
              {item[b] === "" ? " " : item[b]}
            </Text>
          ) : null}
          {/* {`i-${index}-${index2}`} */}
        </Table.Cell>
      );
    })}
    {/* <Table.Cell fontSize={"xl"}>{item.category}</Table.Cell> */}
    {/* <Table.Cell textAlign="end" fontSize={"xl"}> */}
    {/* {item.price} */}
    {/* </Table.Cell> */}
  </Table.Row>
);

// const Rows = (props) =>
//   props?.items?.map((item, index) => (
//     <Item key={`row-${index}`} item={item} index={index} {...props} />
//   ));

const TableList = ({
  headers,
  items,
  selectedItem,
  onSelect,
  type,
  minH,
  h,
  colGroup,
}) => {
  const selectedId = selectedItem?.item?.id || "";

  const onClickItm = (data) => {
    onSelect && onSelect(data);
  };

  // return <Flex bg={"red"} flex={1}></Flex>;

  const tsProps = {
    mt: "2rem",
    minH: "6rem",
  };

  if (minH) {
    tsProps.minH = minH;
  }

  if (type === "simple") {
    tsProps.mt = 0;
  }

  if (type === "w-100") {
    tsProps.mt = 0;
    tsProps.w = "100%";
  }

  if (h) {
    tsProps.minH = h;
    tsProps.maxH = h;
  }

  return (
    <Table.ScrollArea borderWidth="1px" rounded="md" flex={1} {...tsProps}>
      <Table.Root size="sm" stickyHeader>
        {/* {colGroup ? (
          <Table.ColumnGroup>
            {colGroup.map((a, ind) => {
              return <Table.Column key={"tch" + ind} htmlWidth={a} />;
            })}
          </Table.ColumnGroup>
        ) : null} */}

        {headers ? (
          <Table.ColumnGroup>
            {headers.map((a, ind) => {
              return (
                <Table.Column key={"tch" + ind} htmlWidth={a?.colW || ""} />
              );
            })}
          </Table.ColumnGroup>
        ) : null}

        <Table.Header>
          <Table.Row bg={"primary"}>
            {headers
              ? headers?.map((a, index) => {
                  let lb = "";

                  if (a?.label) {
                    lb = a?.label;
                    if (lb?.toLocaleUpperCase) {
                      lb = lb.toLocaleUpperCase();
                    }
                  } else if (a?.toLocaleUpperCase) {
                    lb = a.toLocaleUpperCase();
                  }

                  return (
                    <Table.ColumnHeader
                      key={`h-${index}`}
                      color={"white"}
                      fontSize={size}
                      {...a?.style}
                      // fontWeight={'bold'}
                    >
                      {lb}
                    </Table.ColumnHeader>
                  );
                })
              : Object?.keys(items && items[0]).map((a, index) => {
                  if (a === "id") {
                    return null;
                  }
                  return (
                    <Table.ColumnHeader
                      key={`h-${index}`}
                      color={"white"}
                      fontSize={size}
                    >
                      {a}
                    </Table.ColumnHeader>
                  );
                })}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {items.map((item, index) => (
            <Item
              key={item?.id}
              index={index}
              selectedId={selectedId}
              onClickItm={onClickItm}
              item={item}
            />
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );

  // return (
  //   // <Flex
  //   //   alignItems={"flex-start"}
  //   //   justifyContent={"flex-start"}
  //   //   flex={1}
  //   //   overflow={"scroll"}
  //   // >
  //   <Table.ScrollArea
  //     flex={1}
  //     borderRadius={"0.5rem"}
  //     mt="3"
  //     borderWidth="1px"
  //     h={"500px"}
  //   >
  //     <Table.Root
  //       // borderWidth={"1px"}
  //       size="sm"
  //       variant="outline"
  //       // overflow={"scroll"}
  //       stickyHeader
  //     >
  //       {/* <Table.ColumnGroup>
  //       <Table.Column htmlWidth="50%" />
  //       <Table.Column htmlWidth="40%" />
  //       <Table.Column />
  //     </Table.ColumnGroup> */}
  //       <Table.Header>
  //         <Table.Row bg={"primary"}>
  //           {headers
  //             ? headers?.map((a, index) => (
  //                 <Table.ColumnHeader
  //                   key={`h-${index}`}
  //                   color={"white"}
  //                   fontSize={size}
  //                 >
  //                   {a}
  //                 </Table.ColumnHeader>
  //               ))
  //             : null}
  //         </Table.Row>
  //       </Table.Header>
  //       <Table.Body>
  //         <Rows
  //           onClickItm={onClickItm}
  //           selectedId={selectedId}
  //           items={items || []}
  //         />
  //       </Table.Body>
  //     </Table.Root>
  //   </Table.ScrollArea>
  //   // </Flex>
  // );
};

export default TableList;
